//#region ../r-html/dist/constants.js
var PREFIX_SPREAD = "...";
var MARKER = `@@r-html-${Math.random().toString().substring(2, 8)}`;
var SPREAD_MARKER = `${PREFIX_SPREAD}${MARKER}`;
var markersRegexp = new RegExp(`${MARKER}_(\\d+)_`, "g");
var markerOnlyRegexp = new RegExp(`^${MARKER}_\\d+_$`);
var nextLineRegexp = /^\n/;
var TAttrType = /* @__PURE__ */ function(TAttrType) {
	TAttrType["attribute"] = "attribute";
	TAttrType["boolean"] = "boolean";
	TAttrType["event"] = "event";
	TAttrType["property"] = "property";
	TAttrType["spread"] = "spread";
	TAttrType["directive"] = "directive";
	return TAttrType;
}({});
var BEFORE_MOUNT = Symbol.for("https://github.com/dineug/r-html#beforeMount");
var MOUNTED = Symbol.for("https://github.com/dineug/r-html#mounted");
var UNMOUNTED = Symbol.for("https://github.com/dineug/r-html#unmounted");
var BEFORE_FIRST_UPDATE = Symbol.for("https://github.com/dineug/r-html#beforeFirstUpdate");
var BEFORE_UPDATE = Symbol.for("https://github.com/dineug/r-html#beforeUpdate");
var FIRST_UPDATED = Symbol.for("https://github.com/dineug/r-html#firstUpdated");
var UPDATED = Symbol.for("https://github.com/dineug/r-html#updated");
var LIFECYCLE_NAMES = [
	BEFORE_MOUNT,
	MOUNTED,
	UNMOUNTED,
	BEFORE_FIRST_UPDATE,
	BEFORE_UPDATE,
	FIRST_UPDATED,
	UPDATED
];
var DIRECTIVE = Symbol.for("https://github.com/dineug/r-html#Directive");
var TEMPLATE_LITERALS = Symbol.for("https://github.com/dineug/r-html#TemplateLiterals");
//#endregion
export { BEFORE_FIRST_UPDATE, BEFORE_MOUNT, BEFORE_UPDATE, DIRECTIVE, FIRST_UPDATED, LIFECYCLE_NAMES, MARKER, MOUNTED, SPREAD_MARKER, TAttrType, TEMPLATE_LITERALS, UNMOUNTED, UPDATED, markerOnlyRegexp, markersRegexp, nextLineRegexp };
